// Small pub/sub so the death panel's "Try Again" button (in ui.ts) can tell the
// running GameScene to restart the current room, without either module needing a
// direct reference to the other -- same pattern as gameReset.ts's onNewGame, just
// scoped to one room rather than the whole world.

const listeners: Array<() => void> = [];

export function onRoomRestart(listener: () => void): void {
  listeners.push(listener);
}

export function triggerRoomRestart(): void {
  listeners.forEach((listener) => listener());
}
